<template>
  <div class="modal">
    <div class="modal__bg" @click="close"></div>
    <div class="modal__body">
      <h4 class="modal__header">
        <span>Share Your Feedback</span>
        <img
          src="~@/assets/media/icons/close.svg"
          alt="close icon"
          @click="close"
        />
      </h4>
      <p>
        Are you a recent visitor, event guest or client? We’d love to hear your
        feedback about the service you have received from our staff or about our
        space. Thank you for your time, we appreciate it!
      </p>
      <div class="row">
        <div class="col">
          <form>
            <div class="form-material form-material--feedback">
              <label>How was your experience?</label>
              <div class="rate">
                <input
                  id="star5"
                  type="radio"
                  @click="rate(5)"
                  name="rate"
                  value="5"
                />
                <label for="star5" />
                <input
                  id="star4"
                  type="radio"
                  @click="rate(4)"
                  name="rate"
                  value="4"
                />
                <label for="star4" />
                <input
                  id="star3"
                  type="radio"
                  @click="rate(3)"
                  name="rate"
                  value="3"
                />
                <label for="star3" />
                <input
                  id="star2"
                  type="radio"
                  @click="rate(2)"
                  name="rate"
                  value="2"
                />
                <label for="star2" />
                <input
                  id="star1"
                  type="radio"
                  @click="rate(1)"
                  name="rate"
                  value="1"
                />
                <label for="star1" />
              </div>
            </div>
            <div class="form-material form-material--feedback">
              <label>Describe your experience</label>
              <textarea
                name="feedback"
                v-model.trim="feedback.feedback"
                class="no-focus form-control"
                rows="4"
                placeholder="Type your feedback here…"
                v-validate="'required'"
                data-vv-as="feedback"
                required
                v-on:focus="handleMouseEnter(true, $event)"
                v-on:blur="handleMouseEnter(false, $event)"
              />
              <div v-if="veeErrors.first('feedback')" class="invalid-feedback">
                {{ veeErrors.first("feedback") }}
              </div>
            </div>
            <ActionButton
              label="Send Feedback"
              class="btn w-auto m-0 d-inline-block mt-3"
              style="border-radius: 0.375rem !important"
              :theme="{ primary, secondary, event, danger }"
              v-if="!loading"
              @customEvent="handleForm"
            />
            <Spinner
              style="display: block;float:left"
              :theme="primary"
              class="mt-3"
              v-if="loading"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { feedBackMailer } from "@/helpers/mailer";

const Spinner = () => import("@/components/Spinner");
const ActionButton = () => import("@/components/ActionButton");

export default {
  name: "UserFeedback",
  components: {
    Spinner,
    ActionButton
  },
  mounted() {
    this.active = this.isOpen;
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  data: () => ({
    loading: false,
    active: false,
    feedback: {
      feedback: "",
      rate: 0,
      user: "",
      email: ""
    }
  }),
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.feedback.user =
      this.$store.getters.getUser.firstName +
      " " +
      this.$store.getters.getUser.lastName;
    this.feedback.email = this.$store.getters.getUser.email;
  },
  methods: {
    close() {
      this.$emit("close");
    },
    rate(value) {
      this.feedback.rate = value;
    },
    async handleForm() {
      try {
        this.loading = true;
        const isFormValid = await this.$validator.validateAll();

        if (!isFormValid) {
          throw new Error("Unable to submit form. Try again.");
        }

        let message = this.feedback;
        let subject = "User Feedback";
        await feedBackMailer({ subject, message });
        this.$swal(
          "Submitted",
          "Thanks for your feedback " + this.$store.getters.getUser.firstName,
          "success"
        ).then(() => {
          this.loading = false;
          this.$emit("close");
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    handleMouseEnter(param, $event) {
      $event.target.style.boxShadow = param
        ? `0 2px 0 ${this.primary}`
        : "0 2px 0 #b5b5b5";
    }
  }
};
</script>

<style lang="scss" scoped>
.h-0 {
  height: 0;
}
.modal {
  display: block;
  min-height: 100vh;
  left: 0;
  width: 100%;
  .row {
    width: auto;
  }
  &__bg {
    background-color: black;
    height: 100%;
    left: 0;
    opacity: 0.5;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0;
  }

  &__body {
    animation: fade-in-up 0.25s ease-out forwards;
    background-color: white;
    border-radius: 5px;
    left: 50%;
    max-height: 600px;
    overflow: auto;
    padding: 40px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 650px;
    @media (max-width: 767px) {
      width: 500px;
    }
    @media (max-width: 575px) {
      width: 300px;
    }
    z-index: 1;
  }
  &__header {
    color: $gray-900;
    font-size: $font-size-base;
    margin-bottom: 40px;
    position: relative;
    img {
      cursor: pointer;
      top: 0;
      position: absolute;
      right: 0;
    }
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    top: 44%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    top: 44%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}

.form-material--feedback {
  padding-top: 20px;
  textarea {
    resize: none;
  }
  > label {
    display: inline-block;
    color: #232323;
    margin-bottom: 20px;
    position: relative;
    top: 0;
    left: 0;
  }
  & + .btn {
    border-radius: 0.375rem !important;
    height: auto;
    padding: 0.78571rem 1.5rem;
    margin-top: 15px;
    width: auto;
    &::before {
      display: none;
    }
  }
}
.rate {
  display: flex;
  align-items: flex-start;
  flex-direction: row-reverse;
  justify-content: flex-end;
  position: relative;
}
.rate:not(:checked) > input {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
}
.rate:not(:checked) > label {
  color: #bebebe;
  cursor: pointer;
  margin-right: 10px;
}
.rate:not(:checked) > label:before {
  content: "★";
  font-size: 30px;
}
.rate > input:checked ~ label {
  color: #ffc700;
}
.rate:not(:checked) > label:hover,
.rate:not(:checked) > label:hover ~ label {
  color: #ffc700;
}
.rate > input:checked + label:hover,
.rate > input:checked + label:hover ~ label,
.rate > input:checked ~ label:hover,
.rate > input:checked ~ label:hover ~ label,
.rate > label:hover ~ input:checked ~ label {
  color: #ffc700;
}
</style>
